import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

export default createSvgIcon(
  <path fill="currentColor" d="M18 2v13.17L16.83 14H2V2zm0-2H2C.9 0 0 .9 0 2v12c0 1.1.9 2 2 2h14l4 4V2c0-1.1-.9-2-2-2m-2 10H4v2h12zm0-3H4v2h12zm0-3H4v2h12z" />
, 'ActionCommentOutlinedx');
